import { request } from '@api/request'
import Constants from '@helpers/Constants'
import { AvailableLanguage } from '@helpers/language/AvailableLanguages'
import type { Language } from '@models/Language'
import type { Level } from '@models/Level'
import { Model } from '@models/Model'
import { RelativeDateDTO } from '@models/api/time/RelativeDateDTO'
import type { Bulletin } from '@models/bulletin/Bulletin'
import { Position } from '@models/map/Position'
import type { Dayjs } from 'dayjs'

function getLocalBulletinPDFUrl(
  bulletinID: Bulletin['id'],
  position?: Position
) {
  let url = `${Constants.fileGeneratorUrl}/bulletin/generateBulletinPdf/${bulletinID}`

  if (position) {
    url += `?lat=${position.lat}&lon=${position.lon}`
  }

  return url
}

export const fileGeneratorLocal = {
  getBulletinImageLocal: async (
    bulletinID: Bulletin['id'],
    levelID: Level['id'],
    mapDate: Dayjs,
    isWindActive: boolean = false
  ) => {
    const url = `${Constants.fileGeneratorUrl}/mapImage/generateBulletinMapImage`
    return request
      .get(url, {
        params: {
          bulletinID,
          levelID,
          mapDate: mapDate.toISOString(),
          isWindActive
        },
        responseType: 'blob'
      })
      .then((response) => {
        return response.data
      })
  },

  getLegendImageLocal: async (
    levelID: Level['id'],
    language: Language['code'] = AvailableLanguage.ES
  ) => {
    const url = `${Constants.fileGeneratorUrl}/mapImage/generateMapsLegend`
    return request
      .get(url, {
        params: { levelID, language },
        responseType: 'blob'
      })
      .then((response) => {
        return response.data
      })
  },

  getLevelDatesLocal: async (levelId: Level['id']) => {
    const url = `${Constants.localFileGeneratorUrl}/fgb/getLevelAvailableDates`
    return request
      .get(url, {
        params: { levelId }
      })
      .then((response) => {
        return response.data
      })
  },

  getBulletinPDFUrl: (bulletinID: Bulletin['id'], position?: Position) => {
    return getLocalBulletinPDFUrl(bulletinID, position)
  },

  downloadBulletinPDF: async (bulletinID: Bulletin['id']) => {
    const url = getLocalBulletinPDFUrl(bulletinID)
    return request
      .get(url, {
        responseType: 'blob'
      })
      .then((response) => {
        return response.data
      })
  },

  downloadChartImageLocal: async (
    bulletinID: Bulletin['id'],
    levelID: Level['id'],
    relativeDate: RelativeDateDTO
  ) => {
    const url = `${Constants.fileGeneratorUrl}/chart/generateChart`
    return request
      .post(
        url,
        { bulletinID, levelID, relativeDate },
        {
          responseType: 'blob'
        }
      )
      .then((response) => {
        return response.data
      })
  },

  downloadTephigramImageLocal: async (
    bulletinID: Bulletin['id'],
    modelID: Model['id'],
    date: Dayjs
  ) => {
    const url = `${Constants.fileGeneratorUrl}/chart/generateChart`
    return request
      .get(url, {
        params: { bulletinID, modelID, date: date.toISOString() },
        responseType: 'blob'
      })
      .then((response) => {
        return response.data
      })
  }
}
